module.exports = __webpack_public_path__ + "7b8557eabbae959fdde366cabb6d2e73.svg";